/*
 * Text formats (owner, 2026-10-25), the twin of App\Classes\Text::format(): keep the two in step (the server formats
 * again what it's sent; tests/Snapshot/TextFormatTest checks the cases). title: a name in Title Case, Irish names
 * kept right (McNally, O'Neill; MacDonald as typed, Mac-words otherwise as any word), small words lower but first and
 * last; sentence: the first letter raised; upper; lower; none: as typed. Spaces always tidied.
 */
const MINOR = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'if', 'in', 'nor', 'of', 'off', 'on', 'or', 'per', 'so', 'the', 'to', 'up', 'via', 'yet'];

const raise = (text) => text.charAt(0).toUpperCase() + text.slice(1);

// One part of a word (between hyphens), as typed
const part = (typed) => {
    const lower = typed.toLowerCase();
    if (/^mc\p{L}/u.test(lower)) return 'Mc' + raise(lower.slice(2));
    if (/^o'\p{L}/u.test(lower)) return "O'" + raise(lower.slice(2));
    if (/^Mac\p{Lu}/u.test(typed)) return 'Mac' + raise(lower.slice(3));
    return raise(lower);
};

const title = (text) => {
    const words = text.split(' ');
    return words.map((word, index) => {
        const lower = word.toLowerCase();
        const inner = index > 0 && index < words.length - 1 && !/[.!?:,—]$/.test(words[index - 1]);
        return inner && MINOR.includes(lower) ? lower : word.split('-').map(part).join('-');
    }).join(' ');
};

export const format = (value, kind = 'title') => {
    const text = String(value ?? '').replace(/[’‘]/g, "'").trim().replace(/\s+/g, ' ');
    return {
        title: () => title(text),
        sentence: () => raise(text),
        upper: () => text.toUpperCase(),
        lower: () => text.toLowerCase(),
    }[kind]?.() ?? text;
};
